<div class="w-p-100 flex flex-col">
  <form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
        class="title-with-type-container flex flex-col">
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-1-1-100">
        <mat-label>Title</mat-label>
        <input formControlName="title" matInput placeholder="Title">
        <mat-error *ngIf="createPresetCountriesErrors.title.required">
          Title is required!
        </mat-error>
      </mat-form-field>
    </div>
  </form>

  <div class="flex flex-row  full-grow-no-shrink-no-basis ">
    <ng-template #PresetCountriesSelector></ng-template>
  </div>
</div>
